import React from 'react'
import HeaderCarousel from '../educationv2/headerEducation'
import Footer from "../elements/footer";
import Stomach from "../educationv2/stomach"
import { Helmet } from "react-helmet";
import NavBar from '../elements/navBar';

function Education() {
  return (
    <div style={{backgroundColor:"#f3f3f3"}}>
      

         <Helmet>
        <title>Learn modern Tech</title>
       <meta name="description" content="Maker Skills Up is revolutionizing the standard educational system style by tackling the new tech with hands-on workshops and learning by practice using its fabulous equipment, kits, and unique tools." />
       <meta name="keywords" content="Coding, Modern Technologies, Robotics, Drone, IOT, Skills, Education, Hands-on Workshops" />
         </Helmet>
          <HeaderCarousel type={"learn"}/> 
         {/* <div>
         <NavBar/>
         <img className='coverLearnImage' src="images/coverLearn.jpg" alt="" />
         </div> */}
         <Stomach/>
          <Footer/>
    </div>
  )
}

export default Education